import {
	Box,
	Button,
	ButtonBase,
	CircularProgress,
	Grid,
	Tab,
	TextField,
	Tooltip,
	Typography,
} from '@mui/material';
import MainGrid from '../components/MainGrid';
import { MAIN_THEME_COLOR, WHITE } from '../assets/theme/Colors';
import { useState } from 'react';
import { helperText } from '../assets/theme/Theme';
import Dropzone from 'react-dropzone';
import IconButton from '../components/IconButton';
import {
	DownloadIcon,
	SmallWIcon,
	StarIcon,
	UploadSmIcon,
} from '../assets/icons/Icons';
import { getAccessToken, getElderHomeId, getUserId } from '../Utils/AuthUtil';
import { sendClientApiDetails } from '../services/CarePlanServices';
import { toast } from 'react-toastify';
import TextInput from '../components/TextInput';
import CustomTextInput from '../components/CustomTextInput';
import CustomDropdown from '../components/CustomDropdown';
import { ERROR_STATE, ExternalAPIType } from '../Utils/Enums';
import { storeExternalApiConfig } from '../services/ElderService';
import ToastBanner from '../components/ToastBanner';

const ex = `{
	"baseurl": "", // Base url
	"endpoints": [
		{
			"name": "",  // Api name
			"description": "",  // Api description
			"endpoint": "", // Api endpoint
			"method": "", // Api method
			"headers": {}, // Api headers
			"auth_config": {  // Api authentications
				"auth_type": "",
		  		"key": "",
		  		"in": "",
		  		"name": ""
			},
			"path_params": {} // Path parameters,
			"response_mapping":{ // Api response mapping
				"listPath": "",
				"uniqueKey":"",
				"fields": {}
			}
		}
	]
}`;

const TABS = {
	ac: 'API Connector',
	// dm: 'Data Mapping',
};

const API_SETUP = {
	manual: 'Manual Setup',
	// command: 'Paste cURL',
};

const API_INITIAL_STATE = {
	apiName: '',
	endpoint: '',
	method: '',
	authType: '',
	token: '',
	rootField: '',
	uniqueKey: '',
	fields: [
		{ key: 'elderId', value: '' },
		{ key: 'name', value: '' },
	],
	headers: [{ key: '', value: '' }],
	queryParams: [{ key: '', value: '' }],
	requestBody: '',
};

const CURL_API_INITIAL_STATE = {
	rootField: '',
	idKeyField: '',
	requestBody: '',
};

const API_ERROR_STATE = {
	apiName: ERROR_STATE,
	endpoint: ERROR_STATE,
	method: ERROR_STATE,
	authType: ERROR_STATE,
	token: ERROR_STATE,
	rootField: ERROR_STATE,
	uniqueKey: ERROR_STATE,
	fields: ERROR_STATE,
	headers: ERROR_STATE,
	queryParams: ERROR_STATE,
};

const CURL_API_ERROR_STATE = {
	rootField: ERROR_STATE,
	idKeyField: ERROR_STATE,
	requestBody: ERROR_STATE,
};

const METHODS = ['GET', 'POST'];

const AUTH_TYPES = ['NONE', 'BEARER', 'BASIC', 'API_KEY', 'API_KEY_QUERY'];

function CustomMultiInput({
	data,
	onChange,
	onAdd,
	onRemove,
	type,
	error,
	hideAddRemoveOption = false,
}) {
	return (
		<Grid
			sx={{
				border: '1px solid #ccc',
				borderRadius: 1,
				overflow: 'hidden',
				mb: 2,
			}}>
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: '1fr 1fr 70px',
					backgroundColor: '#ffffff',
					p: 1,
					borderBottom: '1px solid #ccc',
					fontWeight: 500,
				}}>
				<Box sx={{ fontSize: '14px' }}>Key</Box>
				<Box sx={{ fontSize: '14px' }}>Value</Box>
			</Box>
			{data.map((header, index) => (
				<Grid
					container
					key={index}
					alignItems="center"
					sx={{
						borderBottom:
							index < data.length - 1 ? '1px solid #eee' : 'none',
						p: 1,
					}}>
					<Grid item xs={5}>
						<TextInput
							value={header.key}
							onChange={value =>
								onChange(type, index, 'key', value)
							}
							placeholder="key"
							width={'100%'}
						/>
					</Grid>
					<Grid item xs={5} paddingLeft={'15px'}>
						<TextInput
							value={header.value}
							onChange={value =>
								onChange(type, index, 'value', value)
							}
							placeholder="value"
							width={'100%'}
						/>
					</Grid>
					{!hideAddRemoveOption && (
						<Grid item xs={2} paddingLeft={'10px'}>
							<Button
								color="error"
								sx={{ textTransform: 'none', fontSize: '12px' }}
								onClick={() => onRemove(type, index)}>
								Remove
							</Button>
						</Grid>
					)}
				</Grid>
			))}
			{!hideAddRemoveOption && (
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						paddingBottom: '5px',
						paddingLeft: '8px',
					}}>
					<Button
						variant="outlined"
						sx={{
							textTransform: 'none',
							fontSize: '12px',
							color: MAIN_THEME_COLOR,
							borderColor: MAIN_THEME_COLOR,
						}}
						onClick={() => onAdd(type)}>
						Add
					</Button>
				</Box>
			)}
			{error?.status && (
				<Typography style={helperText}>{error?.msg}</Typography>
			)}
		</Grid>
	);
}

function ResidentApiCommand({ command, onChange, apiErrors }) {
	return (
		<Grid container>
			<Grid container>
				<Typography
					fontSize={'14px'}
					color={'#7C7C7C'}
					marginBottom={'5px'}>
					Api cURL Command
				</Typography>
				<TextField
					fullWidth
					multiline
					minRows={8}
					value={command.cUrlCommand}
					onChange={e => onChange(e.target.value, 'requestBody')}
					sx={{
						'& .MuiOutlinedInput-root': {
							color: '#777E90',
							fontSize: '14px',
						},
					}}
					error={apiErrors.requestBody?.status}
				/>
				<Typography style={helperText}>
					{apiErrors.requestBody?.msg}
				</Typography>
			</Grid>
			<Grid flexDirection={'row'} display={'flex'} width={'100%'}>
				<CustomTextInput
					label={'Root field'}
					value={command?.rootField}
					error={apiErrors?.rootField}
					onChange={value => onChange(value, 'rootField')}
					smallerLabel={true}
					showRequiredMark={false}
				/>
				<CustomTextInput
					label={'ID Field Key'}
					value={command?.idKeyField}
					error={apiErrors?.idKeyField}
					onChange={value => onChange(value, 'idKeyField')}
					smallerLabel={true}
					showRequiredMark={false}
					width="100%"
				/>
			</Grid>
		</Grid>
	);
}

function ManualResidentApi({
	apiData,
	onChangeData,
	apiErrors,
	onAddNewInput,
	onRemoveInput,
	onChangeMultiInput,
}) {
	return (
		<Grid>
			<Grid flexDirection={'row'} display={'flex'} width={'100%'}>
				<CustomTextInput
					label={'Api Name'}
					value={apiData?.apiName}
					error={apiErrors?.apiName}
					onChange={value => onChangeData(value, 'apiName')}
					smallerLabel={true}
					showRequiredMark={false}
				/>
				<CustomTextInput
					label={'Endpoint'}
					value={apiData?.endpoint}
					error={apiErrors?.endpoint}
					onChange={value => onChangeData(value, 'endpoint')}
					smallerLabel={true}
					showRequiredMark={false}
					placeholder={'Base url + endpoint'}
					width="100%"
				/>
			</Grid>
			<Grid flexDirection={'row'} display={'flex'} width={'100%'}>
				<CustomDropdown
					label={'Api Method'}
					data={apiData?.method}
					error={apiErrors?.method}
					onChange={e => {
						onChangeData(e.target.value, 'method');
					}}
					items={METHODS}
					placeholder={'Select method'}
					width={'47.5%'}
				/>
			</Grid>
			<Typography sx={{ marginY: '5px', fontSize: '14px' }}>
				Authentications:
			</Typography>
			<Grid flexDirection={'row'} display={'flex'} width={'100%'}>
				<CustomDropdown
					label={'Auth Type'}
					data={apiData?.authType}
					error={apiErrors?.authType}
					onChange={e => {
						onChangeData(e.target.value, 'authType');
					}}
					items={AUTH_TYPES}
					placeholder={'Select method'}
					width={'95%'}
				/>
				<CustomTextInput
					label={'Token'}
					value={apiData?.token}
					error={apiErrors?.token}
					onChange={value => onChangeData(value, 'token')}
					smallerLabel={true}
					showRequiredMark={false}
					width={'100%'}
				/>
			</Grid>
			<Grid
				container
				flexDirection={'row'}
				columnSpacing={3}
				display={'flex'}>
				<Grid item xs={12} md={5.8}>
					<Typography sx={{ marginY: '5px', fontSize: '14px' }}>
						Headers:
					</Typography>
					<CustomMultiInput
						type={'headers'}
						onAdd={onAddNewInput}
						onRemove={onRemoveInput}
						data={apiData?.headers}
						onChange={onChangeMultiInput}
						error={apiErrors?.headers}
					/>
				</Grid>
				<Grid item xs={12} md={6.1} marginLeft={'10px'}>
					<Typography sx={{ marginY: '5px', fontSize: '14px' }}>
						Query Parameters:
					</Typography>
					<CustomMultiInput
						type={'queryParams'}
						onAdd={onAddNewInput}
						onRemove={onRemoveInput}
						data={apiData?.queryParams}
						onChange={onChangeMultiInput}
						error={apiErrors?.queryParams}
					/>
				</Grid>
			</Grid>
			<Typography sx={{ marginY: '5px', fontSize: '14px' }}>
				Response Mapping:
			</Typography>
			<Grid flexDirection={'row'} display={'flex'} width={'100%'}>
				<Grid item xs={12} md={6}>
					<CustomTextInput
						label={'List path'}
						value={apiData?.rootField}
						error={apiErrors?.rootField}
						onChange={value => onChangeData(value, 'rootField')}
						smallerLabel={true}
						showRequiredMark={false}
						placeholder={'Eg: $.data'}
					/>
					<CustomTextInput
						label={'Unique key'}
						value={apiData?.uniqueKey}
						error={apiErrors?.uniqueKey}
						onChange={value => onChangeData(value, 'uniqueKey')}
						smallerLabel={true}
						showRequiredMark={false}
						placeholder={'Eg: $.id'}
					/>
				</Grid>
				<Grid item xs={12} md={6}>
					<Typography sx={{ marginY: '5px', fontSize: '14px' }}>
						Fields:
					</Typography>
					<CustomMultiInput
						type={'fields'}
						onAdd={onAddNewInput}
						onRemove={onRemoveInput}
						data={apiData?.fields}
						onChange={onChangeMultiInput}
						error={apiErrors?.fields}
						hideAddRemoveOption={true}
					/>
				</Grid>
			</Grid>
			<Grid container>
				<Typography
					fontSize={'14px'}
					color={'#7C7C7C'}
					marginBottom={'5px'}>
					Request Body (Optional)
				</Typography>
				<TextField
					fullWidth
					multiline
					minRows={5}
					value={apiData?.requestBody}
					onChange={e => onChangeData(e.target.value, 'requestBody')}
					sx={{
						'& .MuiOutlinedInput-root': {
							color: '#777E90',
							fontSize: '14px',
						},
					}}
				/>
			</Grid>
		</Grid>
	);
}

function APIUpload({
	file,
	readTextFile,
	onUpload,
	inputError,
	loading,
	onSelectApiType,
	selectedApiTab,
	apiData,
	apiErrors,
	onChangeData,
	onAddNewInput,
	onRemoveInput,
	onChangeMultiInput,
	cUrlCommand,
	onChangeCommand,
	commandError,
	isStoringResidentApiConfig,
	onStoreApiConfigs,
}) {
	return (
		<Grid
			container
			sx={{
				backgroundColor: '#FFFFFF',
				borderRadius: '5px',
				padding: '16px',
				flexDirection: 'column',
			}}>
			<Grid
				sx={{
					backgroundColor: '#FAFAFA',
					marginBottom: '4px',
					padding: '26px 26px 26px 26px',
					flexDirection: 'row',
					display: 'flex',
					justifyContent: 'center',
				}}>
				<SmallWIcon />
				<Typography
					fontSize={'14px'}
					color={'#324054'}
					marginLeft={'5px'}>
					Upload a JSON file with API specifications. For each API
					include clear and concise description for query parameters
					and response.
				</Typography>
			</Grid>
			<Grid
				sx={{
					p: 3,
					mb: 3,
					mt: 1,
					textAlign: 'center',
					backgroundColor: '#FAFAFA',
				}}>
				<Typography
					gutterBottom
					color={MAIN_THEME_COLOR}
					fontWeight={'500'}
					fontSize={'16px'}>
					📄 Download JSON Template
				</Typography>
				<Typography sx={{ mb: 2, fontSize: '14px', color: '#324054' }}>
					Please download the template file below and fill it out
					before uploading your data.
				</Typography>
				<Tooltip title="Download the JSON template file">
					<Button
						variant="contained"
						href="/external_api_template.json"
						download
						startIcon={<DownloadIcon />}
						sx={{
							backgroundColor: MAIN_THEME_COLOR,
							textTransform: 'none',
							'&:hover': {
								backgroundColor: MAIN_THEME_COLOR,
							},
						}}>
						Download Template
					</Button>
				</Tooltip>
				<Typography sx={{ mt: 2, fontSize: '12px', color: '#324054' }}>
					This template ensures your data is in the correct format for
					upload.
				</Typography>
			</Grid>
			<Typography
				sx={{
					marginTop: '10px',
					marginBottom: '5px',
					color: MAIN_THEME_COLOR,
					fontWeight: '500',
				}}>
				Provide api details in Json File
			</Typography>
			<Typography
				fontSize={'16px'}
				color={'#324054'}
				paddingBottom={'5px'}
				marginTop={'10px'}>
				Json File
			</Typography>
			<Grid container width={'100%'} columnSpacing={1}>
				<Grid item xs={12} md={11} width={'100%'}>
					<Dropzone
						disabled={loading}
						onDrop={acceptedFiles => readTextFile(acceptedFiles)}>
						{({ getRootProps, getInputProps }) => (
							<section>
								<div
									{...getRootProps()}
									style={{
										padding: '8px',
										border: inputError.status
											? '1px solid red'
											: '1px solid #D9D9D9',
									}}>
									<input {...getInputProps()} />
									{!file ? (
										<>
											<Typography
												fontSize={'14px'}
												color={'#B4B2B2'}>
												Upload json file here
											</Typography>
										</>
									) : (
										<Typography
											fontSize={'14px'}
											color={'#000000'}>
											{file.name}
										</Typography>
									)}
								</div>
							</section>
						)}
					</Dropzone>
					<Typography style={helperText}>{inputError.msg}</Typography>
				</Grid>
				<Grid item xs={12} md={1}>
					<IconButton
						disabled={loading}
						Icon={UploadSmIcon}
						text={'Onboard'}
						onClick={onUpload}
					/>
				</Grid>
			</Grid>
			<Grid
				container
				sx={{
					paddingY: '10px',
					flexDirection: 'column',
					display: 'none', // Remove this code to enable the ui of manual external resident profile api configurations
				}}>
				<Typography
					sx={{
						color: MAIN_THEME_COLOR,
						fontWeight: '500',
						marginTop: '10px',
						marginBottom: '5px',
					}}>
					Provide api details to connect external care system
					residents (Optional)
				</Typography>
				<Grid container sx={{ paddingY: '10px' }}>
					{Object.values(API_SETUP).map((item, index) => {
						return (
							<ButtonBase
								key={index}
								onClick={() => onSelectApiType(item)}
								sx={{
									height: 38,
									backgroundColor:
										item == selectedApiTab
											? '#F9F8F9'
											: WHITE,
									padding: '5px 24px 5px 24px',
									borderBottom:
										item == selectedApiTab
											? `2px solid ${MAIN_THEME_COLOR}`
											: '',
								}}>
								<Typography
									fontSize={'14px'}
									fontWeight={'500'}
									color={
										item === selectedApiTab
											? MAIN_THEME_COLOR
											: '#686868'
									}>
									{item}
								</Typography>
							</ButtonBase>
						);
					})}
				</Grid>
				{selectedApiTab === API_SETUP.manual ? (
					<ManualResidentApi
						apiData={apiData}
						apiErrors={apiErrors}
						onChangeData={onChangeData}
						onAddNewInput={onAddNewInput}
						onRemoveInput={onRemoveInput}
						onChangeMultiInput={onChangeMultiInput}
					/>
				) : (
					<ResidentApiCommand
						command={cUrlCommand}
						onChange={onChangeCommand}
						apiErrors={commandError}
					/>
				)}
				<Grid
					container
					width={'100%'}
					marginTop={'15px'}
					justifyContent={'flex-end'}>
					{isStoringResidentApiConfig ? (
						<Grid sx={{ marginTop: '8px', marginLeft: '25px' }}>
							<CircularProgress
								size={'1.5rem'}
								sx={{ color: '#28696D' }}
							/>
						</Grid>
					) : (
						<IconButton
							Icon={UploadSmIcon}
							text={'Save configurations'}
							onClick={onStoreApiConfigs}
						/>
					)}
				</Grid>
			</Grid>
		</Grid>
	);
}

function DataMapping({ onTest }) {
	return (
		<Grid
			container
			sx={{
				backgroundColor: '#FFFFFF',
				borderRadius: '5px',
				padding: '16px',
				flexDirection: 'column',
			}}>
			<Grid
				container
				sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
				<Typography
					fontSize={'16px'}
					color={'#324054'}
					paddingBottom={'5px'}
					fontWeight={'500'}>
					Data Mapping
				</Typography>
				<Button
					onClick={onTest}
					sx={{
						border: '1px solid #28696D',
						paddingLeft: '15px',
						paddingRight: '15px',
						color: '#28696D',
						textTransform: 'none',
						marginRight: '10px',
					}}>
					{'Test Pipeline'}
				</Button>
			</Grid>
		</Grid>
	);
}

function APIIntegration() {
	const token = getAccessToken();
	const [tab, selectedTab] = useState(TABS.ac);
	const userId = getUserId();
	const homeId = getElderHomeId();
	const [fileData, setFileData] = useState('');
	const [txtError, setTxtError] = useState({ status: false, msg: '' });
	const [isLoading, setIsLoading] = useState(false);
	const [isStoringReApiConfig, setIsStoringReApiConfig] = useState(false);
	const [apiTypeTab, setApiTypeTab] = useState('Manual Setup');
	const [manualApiData, setManualApiData] = useState(API_INITIAL_STATE);
	const [manualApiErrors, setManualApiError] = useState(API_ERROR_STATE);
	const [cUrlCommand, setCurlCommand] = useState(CURL_API_INITIAL_STATE);
	const [commandError, setCommandError] = useState(CURL_API_ERROR_STATE);
	const [loadingMsg, setLoadingMsg] = useState('');
	const [isGenerationComplete, setIsGenerationComplete] = useState(false);

	async function onSelect(item) {
		selectedTab(item);
		// if (item === TABS.doc) {
		// 	fetchUploads();
		// } else {
		// 	fetchUploadURLs();
		// }
	}

	function readTextFile(e) {
		const ext = e[0].path.split('.').pop().toLowerCase();

		if (!['json'].includes(ext)) {
			setTxtError({ status: true, msg: 'Invalid file format.' });
			return;
		}

		setTxtError({ status: false, msg: '' });
		setFileData(e[0]);
	}

	function validateManualApiInputs() {
		let isValid = true;

		if (!manualApiData.apiName || manualApiData.apiName === '') {
			setManualApiError(prevState => ({
				...prevState,
				apiName: {
					status: true,
					msg: 'Enter api name',
				},
			}));
			isValid = false;
		}

		if (!manualApiData.authType || manualApiData.authType === '') {
			setManualApiError(prevState => ({
				...prevState,
				authType: {
					status: true,
					msg: 'Select auth type',
				},
			}));
			isValid = false;
		}

		if (!manualApiData.endpoint || manualApiData.endpoint === '') {
			setManualApiError(prevState => ({
				...prevState,
				endpoint: {
					status: true,
					msg: 'Enter endpoint',
				},
			}));
			isValid = false;
		}

		if (!manualApiData.method || manualApiData.method === '') {
			setManualApiError(prevState => ({
				...prevState,
				method: {
					status: true,
					msg: 'Select api method',
				},
			}));
			isValid = false;
		}

		if (!manualApiData.token || manualApiData.token === '') {
			setManualApiError(prevState => ({
				...prevState,
				token: {
					status: true,
					msg: 'Enter api token',
				},
			}));
			isValid = false;
		}

		if (!manualApiData.rootField || manualApiData.rootField === '') {
			setManualApiError(prevState => ({
				...prevState,
				rootField: {
					status: true,
					msg: 'Enter list path for request mapping',
				},
			}));
			isValid = false;
		}

		if (!manualApiData.uniqueKey || manualApiData.uniqueKey === '') {
			setManualApiError(prevState => ({
				...prevState,
				uniqueKey: {
					status: true,
					msg: 'Enter unique key for request mapping',
				},
			}));
			isValid = false;
		}

		if (
			!manualApiData.fields ||
			manualApiData.fields.some(f => !f.value?.trim())
		) {
			setManualApiError(prevState => ({
				...prevState,
				fields: {
					status: true,
					msg: 'Map the fields for request mapping',
				},
			}));
			isValid = false;
		}

		if (manualApiData.headers.length === 0) {
			setManualApiError(prevState => ({
				...prevState,
				headers: {
					status: true,
					msg: 'Enter api headers',
				},
			}));
			isValid = false;
		}

		if (manualApiData.queryParams.length === 0) {
			setManualApiError(prevState => ({
				...prevState,
				queryParams: {
					status: true,
					msg: 'Enter api query parameters',
				},
			}));
			isValid = false;
		}

		return isValid;
	}

	function validateCommandApiInputs() {
		let isValid = true;

		if (!cUrlCommand.idKeyField || cUrlCommand.idKeyField === '') {
			setCommandError(prevState => ({
				...prevState,
				idKeyField: {
					status: true,
					msg: 'Enter id key id in api response',
				},
			}));
			isValid = false;
		}

		if (!cUrlCommand.rootField || cUrlCommand.rootField === '') {
			setCommandError(prevState => ({
				...prevState,
				rootField: {
					status: true,
					msg: 'Enter root field in api response',
				},
			}));
			isValid = false;
		}

		if (!cUrlCommand.requestBody || cUrlCommand.requestBody === '') {
			setCommandError(prevState => ({
				...prevState,
				requestBody: {
					status: true,
					msg: 'Enter cUrl command',
				},
			}));
			isValid = false;
		}

		return isValid;
	}

	async function onUploadJsonFile() {
		if (!fileData) {
			setTxtError({ status: true, msg: 'Select json file' });
			return;
		}

		setIsLoading(true);
		setLoadingMsg('Uploading configuration');
		const formData = new FormData();
		formData.append('file', fileData);
		formData.append('client_id', getElderHomeId());

		const response = await sendClientApiDetails(formData);

		if (!response.error) {
			onStoreExternalApiDetails();
		} else {
			toast.error(response.message);
		}
	}

	async function onStoreExternalApiDetails() {
		if (!fileData) return;

		setIsLoading(true);
		setLoadingMsg('Onboarding Elders');

		const reader = new FileReader();
		reader.onload = event => {
			try {
				const json = JSON.parse(event.target.result);

				if (json.endpoints) {
					const authConfig = json.auth_config;
					const residentApi = json.endpoints.residentApi;
					const careNoteApi = json.endpoints.careNoteApi;
					const carePlanApi = json.endpoints.carePlanApi.find(
						api => api.primary,
					);
					const otherApi = json.endpoints.carePlanApi.filter(
						api => !api.primary,
					);

					onStoreApiConfigs(
						[
							{ data: residentApi, type: ExternalAPIType.reApi },
							{ data: careNoteApi, type: ExternalAPIType.cnApi },
							{ data: carePlanApi, type: ExternalAPIType.cpApi },
							...otherApi.map(api => ({
								data: api,
								type: ExternalAPIType.otApi,
							})),
						],
						authConfig,
					);
				} else {
					alert("JSON does not contain 'endpoints' object");
				}
			} catch (err) {
				alert('Invalid JSON file');
			}
		};
		reader.readAsText(fileData);

		setTimeout(() => {
			setFileData('');
			setIsGenerationComplete(false);
			setIsLoading(false);
		}, 1000);
	}

	// Unused Function
	async function onStoreApiConfigsManual() {
		const isInputsValid = validateManualApiInputs();
		if (!isInputsValid) {
			return;
		}

		setIsStoringReApiConfig(true);

		const formattedHeaders = Object.fromEntries(
			(manualApiData?.headers ?? [])
				.filter(h => h.key && h.value)
				.map(h => [h.key, h.value]),
		);

		const formattedQueryParams = Object.fromEntries(
			(manualApiData?.queryParams ?? [])
				.filter(h => h.key && h.value)
				.map(h => [h.key, h.value]),
		);

		const formattedPathParams = Object.fromEntries(
			(manualApiData?.pathParams ?? [])
				.filter(h => h.key && h.value)
				.map(h => [h.key, h.value]),
		);

		const formattedField = Object.fromEntries(
			(manualApiData?.fields ?? [])
				.filter(h => h.key && h.value)
				.map(h => [h.key, h.value]),
		);

		const apiData = {
			apiName: manualApiData.apiName,
			method: manualApiData.method,
			endpoint: manualApiData.endpoint,
			authType: manualApiData.authType,
			token: manualApiData.token,
			headers: formattedHeaders,
			pathParams: formattedPathParams,
			queryParams: formattedQueryParams,
			requestBody: manualApiData.requestBody,
			rootField: manualApiData.rootField,
			uniqueKey: manualApiData.uniqueKey,
			fields: formattedField,
			authName: 'Authorization',
			authIn: 'header',
		};

		onStoreApiConfigs(apiData, ExternalAPIType.reApi, true);
		setIsStoringReApiConfig(false);
	}

	async function onStoreApiConfigs(
		apiDataList,
		authConfig,
		manualSetup = false,
	) {
		const body = apiDataList.map(apiDataObj => {
			const apiData = apiDataObj.data;

			return {
				name: apiData.name,
				method: apiData.method,
				endpoint: apiData.endpoint,
				authType: authConfig.auth_type,
				token: authConfig.key,
				headers: apiData.headers,
				pathParams: apiData.path_params,
				queryParams: apiData.query_params,
				requestBody: '',
				responseMapping: {
					listPath: apiData.response_mapping.listPath,
					uniqueKey: apiData.response_mapping.uniqueKey,
					fields: apiData.response_mapping.fields,
				},
				sourceType: 'manual',
				elderHomeId: homeId,
				adminId: userId,
				apiType: apiDataObj.type,
				authName: authConfig.name,
				authIn: authConfig.in,
			};
		});

		const response = await storeExternalApiConfig(token, body);
		if (!response.error) {
			if (response.content.externalSyncSuccess) {
				setIsGenerationComplete(true);
				setLoadingMsg('Onboarding Successfully');
				setManualApiData(API_INITIAL_STATE);
			} else {
				setIsGenerationComplete(false);
				setIsLoading(false);
				toast.error(response.content.externalErrors[0]);
			}
		} else {
			toast.error(response.message);
		}
	}

	function onChangeApiData(value, name) {
		setManualApiError(prevState => ({
			...prevState,
			[name]: ERROR_STATE,
		}));

		setManualApiData(prevState => ({
			...prevState,
			[name]: value,
		}));
	}

	const handleAddNewInput = name => {
		const data = manualApiData[name];
		setManualApiData(prevState => ({
			...prevState,
			[name]: [...data, { key: '', value: '' }],
		}));
	};

	const handleRemoveInput = (name, index) => {
		const updated = manualApiData[name].filter((_, i) => i !== index);
		setManualApiData(prevState => ({
			...prevState,
			[name]: updated,
		}));
	};

	const handleMultiChange = (name, index, field, value) => {
		const updated = manualApiData[name];
		updated[index][field] = value;
		setManualApiData(prevState => ({
			...prevState,
			[name]: updated,
		}));
	};

	function onChangeCurlApiData(value, name) {
		setCommandError(prevState => ({
			...prevState,
			[name]: ERROR_STATE,
		}));

		setCurlCommand(prevState => ({
			...prevState,
			[name]: value,
		}));
	}

	return (
		<MainGrid>
			<Grid
				container
				paddingLeft="30px"
				paddingBottom={'20px'}
				flexDirection={'column'}>
				<Typography variant="h6" fontWeight={'600'} color="#28696D">
					API Integration Control Panel
				</Typography>
				<Typography sx={{ color: '#5E5C5C', fontSize: '14px' }}>
					Manage external care systems and data connectors
				</Typography>
			</Grid>
			<Grid
				container
				sx={{
					backgroundColor: '#FFFFFF',
					borderRadius: '5px',
					marginLeft: '30px',
					paddingX: '8px',
				}}>
				<Grid
					container
					flexDirection={'row'}
					columnGap={1}
					padding={'10px'}>
					{Object.values(TABS).map((item, index) => (
						<ButtonBase
							key={index}
							onClick={() => onSelect(item)}
							sx={{
								height: 38,
								backgroundColor:
									item == tab ? '#F9F8F9' : WHITE,
								padding: '5px 24px 5px 24px',
								borderBottom:
									item == tab
										? `2px solid ${MAIN_THEME_COLOR}`
										: '',
							}}>
							<Typography
								fontSize={'14px'}
								fontWeight={'500'}
								color={
									item == tab ? MAIN_THEME_COLOR : '#686868'
								}>
								{item}
							</Typography>
						</ButtonBase>
					))}
				</Grid>
			</Grid>
			<Grid
				container
				sx={{
					backgroundColor: '#FFFFFF',
					borderRadius: '5px',
					marginLeft: '30px',
					marginTop: '8px',
					padding: '0px 10px 0px 10px',
				}}>
				{tab === TABS.ac ? (
					<APIUpload
						onUpload={onUploadJsonFile}
						readTextFile={readTextFile}
						inputError={txtError}
						file={fileData}
						loading={isLoading}
						selectedApiTab={apiTypeTab}
						onSelectApiType={setApiTypeTab}
						apiData={manualApiData}
						onChangeData={onChangeApiData}
						onAddNewInput={handleAddNewInput}
						onRemoveInput={handleRemoveInput}
						onChangeMultiInput={handleMultiChange}
						cUrlCommand={cUrlCommand}
						onChangeCommand={onChangeCurlApiData}
						commandError={commandError}
						apiErrors={manualApiErrors}
						isStoringResidentApiConfig={isStoringReApiConfig}
						onStoreApiConfigs={onStoreApiConfigsManual}
					/>
				) : (
					<DataMapping />
				)}
			</Grid>
			{isLoading && (
				<ToastBanner
					open={isLoading}
					message={loadingMsg}
					icon={<StarIcon color={'#FFFFFF'} />}
					isCompleted={isGenerationComplete}
				/>
			)}
		</MainGrid>
	);
}

export default APIIntegration;
